import React from "react";
import ReactDOM from "react-dom/client";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";

import "./i18n";

import { App } from "./App";

// Prevent users from being able to check values of states/contexts in production
if (import.meta.env.PROD) {
  disableReactDevTools();
}

const queryClient = new QueryClient({
  //   queryCache: new QueryCache({
  //     onError: (error: any, query: any) => {
  //       import.meta.env.DEV && console.error(error);
  //       showErrorNotification({ title: "oops", message: "test-error" });
  //       sessionStorage.clear();
  //       setTimeout(() => window.location.replace("/"), 2000);

  // if (error.response.status === 401) {
  // }

  // 🎉 only show error toasts if we already have data in the cache
  // which indicates a failed background update
  // if (query.state.data !== undefined) {
  //   showErrorNotification(`Something went wrong: ${error.message}`);
  // }
  //   },
  // }),
  // mutationCache: new MutationCache({
  //   onError: (
  //     error: any,
  //     variables: unknown,
  //     context: unknown,
  //     mutation: any
  //   ) => {
  //     if (error.response.status === 401 && !mutation?.meta?.isSignIn) {
  //       showErrorNotification(
  //         `We couldn't verify your credentials.
  //         Redirecting you to sign in page....`
  //       );
  //       sessionStorage.clear();
  //       setTimeout(() => window.location.replace("/"), 4000);
  //     } else if (error.response.status === 401 && mutation?.meta?.isSignIn) {
  //       showErrorNotification("Username or password is invalid");
  //     } else if (error.response.status >= 500) {
  //       showErrorNotification("Something went really wrong: " + error.message);
  //     }
  //     import.meta.env.DEV && console.error(error);
  //   },
  // }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10,
      // refetchOnMount: "always",
      refetchOnReconnect: "always",
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// In the video call scenario, set mode to "rtc"
const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools position="bottom-right" />
      <AgoraRTCProvider client={client}>
        <App />
      </AgoraRTCProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
